<script setup lang="ts">
	import type { ClassNameValue } from 'tailwind-merge'

	defineProps<{
		title?: string
		titleClass?: ClassNameValue
		descClass?: ClassNameValue
		description?: string
		useButton?: boolean
		iconPosition?: 'top' | 'bottom'
	}>()
</script>

<template>
	<div class="flex flex-col items-center justify-center">
		<slot v-if="iconPosition === 'top'" name="icon" />
		<slot name="title">
			<h4
				v-show="title"
				class="text-lg font-semibold capitalize"
				:class="cn('text-gray-700 md:text-[24px]', titleClass)"
			>
				{{ title }}
			</h4>
		</slot>
		<slot name="description">
			<p
				v-show="description"
				:class="
					cn(
						'mx-auto mb-10 text-center text-sm font-normal leading-tight text-gray-500 md:text-base',
						descClass
					)
				"
			>
				{{ description }}
			</p>
		</slot>
		<slot v-if="!iconPosition || iconPosition === 'bottom'" name="icon" />

		<slot v-if="useButton" name="button" />
	</div>
</template>
